import { render, staticRenderFns } from "./CdrHistory.vue?vue&type=template&id=36d4d16c&scoped=true&"
import script from "./CdrHistory.vue?vue&type=script&lang=js&"
export * from "./CdrHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d4d16c",
  null
  
)

export default component.exports